import { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { currentPostAtom } from "../atom";

import styled from "styled-components";
import { Button } from "antd";

import { BarChart, PieChart } from "../component/dashboard";
import { BarChartProps } from "../component/dashboard/BarChart";
import { PieChartProps } from "../component/dashboard/PieChart";
import { getStatistic, postStatisticExcel } from "../api/statisticAPI";

const GenderData = [
  {
    id: "Male",
    value: 55,
  },
  {
    id: "Female",
    value: 43,
  },
];

const AgeData = [
  {
    age: "0",
    count: 20,
  },
  {
    age: "1~5",
    count: 58,
  },
  {
    age: "6~10",
    count: 1,
  },
  {
    age: "11~15",
    count: 9,
  },
  {
    age: "16~20",
    count: 8,
  },
  {
    age: "21~25",
    count: 2,
  },
];

const SiteData = [
  {
    id: "Kidney",
    value: 98,
  },
];

const OPday = [
  {
    year: "1996",
    count: 1,
  },
  {
    year: "2005",
    count: 1,
  },
  {
    year: "2006",
    count: 2,
  },
  {
    year: "2009",
    count: 5,
  },
  {
    year: "2010",
    count: 1,
  },
  {
    year: "2011",
    count: 1,
  },
  {
    year: "2013",
    count: 5,
  },
  {
    year: "2014",
    count: 6,
  },
  {
    year: "2015",
    count: 5,
  },
  {
    year: "2016",
    count: 9,
  },
  {
    year: "2017",
    count: 24,
  },
  {
    year: "2018",
    count: 6,
  },
  {
    year: "2019",
    count: 4,
  },
  {
    year: "2020",
    count: 8,
  },
  {
    year: "2021",
    count: 3,
  },
  {
    year: "2022",
    count: 6,
  },
  {
    year: "2023",
    count: 5,
  },
  {
    year: "2024",
    count: 6,
  },
];

const Dashboard = () => {
  const [file, setFile] = useState<any>();
  const [genderData, setGenderData] = useState<PieChartProps>({
    title: "Sex",
    data: [],
  });
  const [ageData, setAgeData] = useState<BarChartProps>({
    title: "Age",
    keys: ["count"],
    index: "age",
    data: [],
  });
  const [siteData, setSiteData] = useState<PieChartProps>({
    title: "Site",
    data: [],
  });
  const [OPdayData, setOPdayData] = useState<BarChartProps>({
    title: "OP day",
    keys: ["count"],
    index: "year",
    data: [],
  });

  const currentPost = useRecoilValue(currentPostAtom);

  const uploadData = async () => {
    await postStatisticExcel(currentPost.id, file[0]);
  };

  useEffect(() => {
    getStatistic(currentPost.id).then((data) => {
      setGenderData({ ...genderData, data: data.genderData });
      setAgeData({ ...ageData, data: data.ageData });
      setSiteData({ ...siteData, data: data.siteData });
      setOPdayData({ ...OPdayData, data: data.opDay });
    });
  }, []);

  return (
    <StPageWrapper>
      <div id="dashboard" style={{ width: "84rem", margin: "0 auto" }}>
        <div>
          <div style={{ fontSize: "1.2rem", marginBottom: "0.4rem" }}>
            Upload Data
          </div>
          <input
            type="file"
            name="file"
            onChange={(event) => setFile(event.target.files)}
          />
          <Button onClick={uploadData}>Submit</Button>
        </div>
        <StChartBox style={{ width: "20rem", height: "20rem" }}>
          <PieChart props={genderData} />
        </StChartBox>
        <StChartBox style={{ width: "60rem", height: "20rem" }}>
          <BarChart props={ageData} />
        </StChartBox>
        <StChartBox style={{ width: "80.4rem", height: "20rem" }}>
          <PieChart props={siteData} />
        </StChartBox>
        <StChartBox style={{ width: "80.4rem", height: "20rem" }}>
          <BarChart props={OPdayData} />
        </StChartBox>
      </div>
    </StPageWrapper>
  );
};

const StPageWrapper = styled("div")({
  width: "100%",
  paddingTop: "1rem",
  paddingBottom: "1rem",
  backgroundColor: "#f6faff",
});

const StChartBox = styled("div")({
  display: "inline-block",
  margin: "0.2rem",
  border: "1px solid gray",
  backgroundColor: "white",
});

export default Dashboard;
